// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blog_blog__7ylCt {
  color: #FFFFFF;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
  margin: 50px auto;
  background: rgba(217, 217, 217, 0.06);
  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);
  border-radius: 26px;
}
@media (max-width: 860px) {
  .Blog_blog__7ylCt {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column-reverse;
    text-align: center;
  }
}
@media (max-width: 580px) {
  .Blog_blog__7ylCt {
    width: 90%;
  }
}
.Blog_blog__7ylCt img {
  width: 60%;
}
@media (max-width: 860px) {
  .Blog_blog__7ylCt img {
    width: 80%;
  }
}
.Blog_blog__7ylCt .Blog_text__ZHtv7 {
  max-width: 400px;
  margin-left: 30px;
}
@media (max-width: 860px) {
  .Blog_blog__7ylCt .Blog_text__ZHtv7 {
    margin-left: 0;
  }
}
.Blog_blog__7ylCt .Blog_text__ZHtv7 p {
  font-size: 20px;
}
.Blog_blog__7ylCt .Blog_text__ZHtv7 h1 {
  font-size: 40px;
  font-family: "hemi_head";
}

.Blog_textBlog1__vaSGT {
  text-align: center;
  margin-top: 70px;
}
.Blog_textBlog1__vaSGT .Blog_titleBlog__IQB7b {
  max-width: 700px;
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin-bottom: 50px;
}
@media (max-width: 860px) {
  .Blog_textBlog1__vaSGT .Blog_titleBlog__IQB7b {
    font-size: 30px;
  }
}
.Blog_textBlog1__vaSGT .Blog_titleBlog__IQB7b:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}

.Blog_blogItem__\\+MMYU {
  width: 80%;
  margin: auto;
  text-align: center;
}
@media (max-width: 580px) {
  .Blog_blogItem__\\+MMYU {
    width: 90%;
  }
}
.Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: auto;
  background: rgba(217, 217, 217, 0.06);
  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);
  border-radius: 26px;
  padding: 20px;
}
.Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g img {
  width: 45%;
  border-color: #EDEDED;
  border-width: 2px;
  border-radius: 0px 0px 0px 98px;
  border-style: solid;
}
@media (max-width: 1100px) {
  .Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g img {
    display: none;
  }
}
.Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g div {
  width: 50%;
}
@media (max-width: 1100px) {
  .Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g div {
    width: 100%;
  }
}
.Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g div h2 {
  color: #EDEDED;
  font-family: hemi_head;
}
.Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g div p {
  color: #EDEDED;
  font-family: Roboto;
}
@media (max-width: 700px) {
  .Blog_blogItem__\\+MMYU .Blog_mainInfo__7WC7g div p {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Blog/Blog.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,qCAAA;EACA,kDAAA;EACA,mBAAA;AACF;AAAE;EAVF;IAWI,eAAA;IACA,uBAAA;IACA,8BAAA;IACA,kBAAA;EAGF;AACF;AAFE;EAhBF;IAiBG,UAAA;EAKD;AACF;AAJE;EACE,UAAA;AAMJ;AALI;EAFF;IAGI,UAAA;EAQJ;AACF;AANE;EACE,gBAAA;EACA,iBAAA;AAQJ;AAPI;EAHF;IAII,cAAA;EAUJ;AACF;AATI;EACE,eAAA;AAWN;AATI;EACE,eAAA;EACA,wBAAA;AAWN;;AAPA;EACE,kBAAA;EACA,gBAAA;AAUF;AATA;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAWF;AAVE;EAZF;IAaG,eAAA;EAaD;AACF;AAXE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAaJ;;AATA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAYF;AAXE;EAJF;IAKI,UAAA;EAcF;AACF;AAbE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;AAeJ;AAdI;EACE,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AAgBN;AAfM;EANF;IAOI,aAAA;EAkBN;AACF;AAhBI;EACE,UAAA;AAkBN;AAjBM;EAFF;IAGI,WAAA;EAoBN;AACF;AAnBM;EACE,cAAA;EACA,sBAAA;AAqBR;AAnBM;EACE,cAAA;EACA,mBAAA;AAqBR;AApBQ;EAHF;IAII,kBAAA;EAuBR;AACF","sourcesContent":[".blog{\n  color: #FFFFFF;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 80%;\n  margin: 50px auto;\n  background: rgba(217, 217, 217, 0.06);\n  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);\n  border-radius: 26px;\n  @media (max-width: 860px) {\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: column-reverse;\n    text-align: center;\n  }\n  @media (max-width: 580px) {\n   width: 90%;\n  }\n  img{\n    width: 60%;\n    @media (max-width: 860px) {\n      width: 80%;\n    }\n  }\n  .text{\n    max-width: 400px;\n    margin-left: 30px;\n    @media (max-width: 860px) {\n      margin-left: 0;\n    }\n    p{\n      font-size: 20px;\n    }\n    h1{\n      font-size: 40px;\n      font-family: \"hemi_head\";\n    }\n  }\n}\n.textBlog1{\n  text-align: center;\n  margin-top: 70px;\n.titleBlog {\n  max-width: 700px;\n  font-family: \"hemi_head\";\n  font-style: italic;\n  font-weight: 400;\n  font-size: 40px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  color: #FFFFFF;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 50px;\n  @media (max-width: 860px) {\n   font-size: 30px;\n  }\n\n  &:before {\n    content: \"\";\n    width: 80%;\n    height: 1px;\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #ED1C24;\n  }\n}\n}\n.blogItem{\n  width: 80%;\n  margin: auto;\n  text-align: center;\n  @media (max-width: 580px) {\n    width: 90%;\n  }\n  .mainInfo{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 80%;\n    margin: auto;\n    background: rgba(217, 217, 217, 0.06);\n    box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);\n    border-radius: 26px;\n    padding: 20px;\n    img{\n      width: 45%;\n      border-color: #EDEDED;\n      border-width: 2px;\n      border-radius: 0px 0px 0px 98px;\n      border-style: solid;\n      @media (max-width: 1100px) {\n        display: none;\n      }\n    }\n    div{\n      width: 50%;\n      @media (max-width: 1100px) {\n        width: 100%;\n      }\n      h2{\n        color: #EDEDED;\n        font-family: hemi_head;\n      }\n      p{\n        color: #EDEDED;\n        font-family: Roboto;\n        @media (max-width: 700px) {\n          text-align: center;\n        }\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog": `Blog_blog__7ylCt`,
	"text": `Blog_text__ZHtv7`,
	"textBlog1": `Blog_textBlog1__vaSGT`,
	"titleBlog": `Blog_titleBlog__IQB7b`,
	"blogItem": `Blog_blogItem__+MMYU`,
	"mainInfo": `Blog_mainInfo__7WC7g`
};
export default ___CSS_LOADER_EXPORT___;
